module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "searchHero"
  }, [_c('h1', [_vm._v("Search Results")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        _vm.setSearchQuery($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": require("./search/Search.svg"),
      "width": "64",
      "height": "64"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "searchResults",
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.results), function(result) {
    return _c('search-result', {
      key: result.slug,
      attrs: {
        "result": result
      }
    })
  }), _vm._v(" "), (!_vm.results || !_vm.results.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try another search")])]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('pagination', {
    attrs: {
      "totalPages": _vm.totalPages
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05759480"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 758
// module chunks = 1